import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { getUserRole } from "../../utils/Utils";
import AdminDashboard from "../../views/GihDashboards/AdminDashboard";

interface PrivateRouteProps {
  element: JSX.Element;
  requiredRole?: string;
  isLoginPage?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  element,
  requiredRole,
  isLoginPage,
}) => {
  const authContext = useContext(AuthContext);
  if (!authContext) {
    return <Navigate to="/no-access" replace />;
  }

  const { isAuthenticated, token } = authContext;

  if (isAuthenticated && isLoginPage) {
    return <Navigate to="/admin" replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const userRole = getUserRole(token);
  if (element.type === AdminDashboard && userRole === "client") {
    return <Navigate to="/admin/students/createstudentclient" replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/no-access" replace />;
  }

  return element || null;
};

export default PrivateRoute;
